import React from 'react';
import ReactDOM from 'react-dom';
import {AiOutlineCloseCircle} from 'react-icons/ai';
import {InfoSheet} from '../utils/Constants.js';


const FAQ = ({ isShowing, hide }) => isShowing ? ReactDOM.createPortal(
  <React.Fragment>
    <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
    <div className="modal-overlay" onClick={hide}/>
      <div className="modal">
        <div className="modal-header">
          <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
            <span aria-hidden="true"><AiOutlineCloseCircle/></span>
          </button>
        </div>
        <div className="infoBox-full">
          <h1 className="center">{InfoSheet.title}</h1>
          {InfoSheet.data.map(
            (item)=> (
              <div>
                <p className="question">{item.question}</p>
                <p className="answer">{item.answer}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  </React.Fragment>, document.body
  ) : null;

export default FAQ
